<lib-breadcrumb [list]="breadcrumbs()"></lib-breadcrumb>
<div class="text-lg font-bold mb-5">Hearing Process</div>

<div class="p-2 md:p-4 space-y-6">

  <form [formGroup]="searchFormGrp" (ngSubmit)="searchHandler()"
    class="bg-fieldset p-4 rounded-lg shadow-sm border border-gray-200">

    <div class="search-grid">

      <app-case-number-search [label]="userType === 'lawyer' ? 'Case Number' : 'Appeal Number'"
        (caseSelected)="onCaseSearchOptionSelected($event)" formControlName="caseNumber">
      </app-case-number-search>


      <div class="form-item">
        <mat-label class="block mb-1 text-sm font-medium">Document Types</mat-label>

        <mat-form-field *ngIf="!isDocTypeReadonly" class="w-full" appearance="outline">
          <mat-select formControlName="docTypeId">
            @for (docType of docTypes(); track docType.docTypeId) {
            <mat-option [value]="docType.docTypeId">{{ docType.docTypeName }}</mat-option>
            }
          </mat-select>
        </mat-form-field>

        <mat-form-field *ngIf="isDocTypeReadonly" class="w-full" appearance="outline">
          <input matInput [value]="docTypeName" readonly />
        </mat-form-field>
      </div>


      <div class="form-actions"> <button type="reset" mat-stroked-button color="primary" class="h-10 w-full md:w-auto"
          (click)="resetHandler()">
          Reset
        </button>
        <button type="submit" mat-flat-button color="primary" class="h-10 w-full md:w-auto">
          Search
        </button>
      </div>

    </div>
  </form>

  @if(caseData()) {
  <div class="bg-fieldset rounded-lg shadow-sm border border-gray-200 overflow-hidden">

    <form class="p-4 space-y-4" [formGroup]="formGrp">

      <div class="flex flex-col md:flex-row justify-between border-b pb-4 mb-4 gap-4">
        <div class="flex flex-col sm:flex-row sm:items-center gap-2">
          <h2 class="text-lg font-bold text-gray-800">{{ caseCategoryName() }} Details</h2>
          @if (!partyDetails().loading) {
          <div class="text-primary text-sm font-medium bg-blue-50 px-3 py-1 rounded">
            <span>{{ partyDetails()[partyRoleType.APPELLANT].value.join(', ') }}</span>
            <span class="mx-2 font-bold text-gray-400">Vs</span>
            <span>{{ partyDetails()[partyRoleType.RESPONDENT].value.join(', ') }}</span>
          </div>
          }
        </div>

        <div class="flex space-x-3 self-end md:self-center">
          @if (caseAssigned()) {
          <button mat-flat-button color="primary" (click)="assignHandler()">
            <mat-icon fontIcon="save" class="mr-1"></mat-icon> Save
          </button>
          <button mat-stroked-button color="warn" (click)="cancelHandler()">
            <mat-icon fontIcon="cancel" class="mr-1"></mat-icon> Cancel
          </button>
          } @else {
          <button mat-flat-button color="primary" (click)="editHandler()">
            <mat-icon fontIcon="edit" class="mr-1"></mat-icon> Edit
          </button>
          }
        </div>
      </div>

      <div class="grid grid-cols-1 sm:grid-cols-3 gap-6 mb-6 bg-gray-50 p-3 rounded border border-gray-100">
        <div>
          <p class="text-xs text-gray-500 uppercase font-semibold">{{ caseCategoryName() }} Number</p>
          <p class="font-medium truncate">{{ caseData()?.courtCaseNumber }}</p>
        </div>
        <div>
          <p class="text-xs text-gray-500 uppercase font-semibold">Court Division</p>
          <p class="font-medium truncate">{{ caseData()?.courtUnitName }}</p>
        </div>
        <div>
          <p class="text-xs text-gray-500 uppercase font-semibold">{{ caseCategoryName() }} Type</p>
          <p class="font-medium truncate">{{ caseData()?.ctpShortName }}</p>
        </div>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">

        <div class="w-full">
          <mat-label class="block mb-1 text-sm">Document Types</mat-label>
          <mat-form-field class="w-full" appearance="outline">
            <mat-select formControlName="docTypeId" (selectionChange)="docTypesByCaseNoChange($event)">
              @for (docType of docTypesByCaseNo(); track docType.docTypeId) {
              <mat-option [value]="docType.docTypeId">{{ docType.docTypeName }}</mat-option>
              }
            </mat-select>
            <mat-error>Field value required</mat-error>
          </mat-form-field>
        </div>

        <div class="w-full">
          <mat-label class="block mb-1 text-sm">{{ caseCategoryName() }} Phase Type</mat-label>
          <mat-form-field class="w-full" appearance="outline">
            <mat-select formControlName="casePhaseId" (selectionChange)="casePhaseChange($event)">
              @for (cp of casePhases(); track cp.documentTypeCasePhaseTypeId) {
              <mat-option [value]="cp.documentTypeCasePhaseTypeId">{{ cp.phaseName }}</mat-option>
              }
            </mat-select>
            <mat-error>Field value required</mat-error>
          </mat-form-field>
        </div>

        <!-- @if(isJudgement){
        <div class="w-full">
          <label class="block mb-1 text-sm required-label">Judgement Date</label>
          <mat-form-field appearance="outline" class="w-full">
            <input matInput [matDatepicker]="picker" formControlName="judgementDate" placeholder="Select date"
              (dateChange)="onDateChange($event)" [max]="minDate" />
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
        </div>
        } -->

        @if (isRulingDocType()) {
        <div class="w-full">
          <mat-label class="block mb-1 text-sm">Status</mat-label>
          <mat-form-field class="w-full" appearance="outline">
            <mat-select formControlName="motionDocumentStatus">
              @for (cp of status; track cp) {
              <mat-option [value]="cp">{{ cp }}</mat-option>
              }
            </mat-select>
            <mat-error>Field value required</mat-error>
          </mat-form-field>
        </div>
        }
      </div>

      <div class="w-full mt-2">
        <mat-label class="block mb-1 text-sm font-medium">
          <span *ngIf="isCommentsRequired" class="text-red-600">*</span>Comments
        </mat-label>
        <mat-form-field class="w-full" appearance="outline">
          <textarea matInput formControlName="comments" rows="4" placeholder="Enter comments here..."
            maxlength="3500"></textarea>
        </mat-form-field>
      </div>
    </form>

    <div class="p-4 border-t border-gray-200 bg-gray-50">
      <h3 class="text-md font-semibold mb-3">Attachments</h3>

      <form [formGroup]="docFormGrp" (ngSubmit)="onFileUpload()" *ngIf="!isEdit()" class="mb-6">
        <div class="flex flex-wrap items-center gap-x-6 gap-y-4">

          <div class="flex items-center h-[42px]">
            <label class="text-sm font-semibold whitespace-nowrap mr-3 leading-[42px]">Select File:</label>
            <input type="file" formControlName="file" (change)="onFileSelectionChange($event)" class="block w-[220px] h-[42px] text-sm text-slate-500
                file:mr-4 file:h-full file:px-4
                file:rounded-l-md file:border-0
                file:text-sm file:font-semibold
                file:bg-green-50 file:text-green-700
                hover:file:bg-green-100
                border border-gray-300 rounded-md bg-white" />
          </div>

          <div class="flex items-center h-[42px]">
            <label class="text-sm font-semibold whitespace-nowrap mr-3 leading-[42px]">Date Received:</label>
            <mat-form-field appearance="outline" class="w-[180px] no-subscript-wrapper pt-5">
              <input matInput formControlName="docUploadDateReceived" [matDatepicker]="picker2" [max]="today" />
              <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
              <mat-datepicker #picker2></mat-datepicker>
            </mat-form-field>
          </div>

          <div class="flex items-center h-[42px]">
            <button type="submit" mat-flat-button class="h-[42px] min-w-[140px]"
              [disabled]="!isFileSelected() || uploadLoading()" [color]="isFileSelected() ? 'primary' : ''">
              <mat-icon *ngIf="!uploadLoading()" fontIcon="upload" class="mr-2"></mat-icon>
              <mat-icon *ngIf="uploadLoading()" class="animate-spin mr-2">sync</mat-icon>
              {{ uploadLoading() ? 'Uploading...' : 'Upload File' }}
            </button>
          </div>
        </div>
      </form>

      <div class="overflow-x-auto w-full border rounded-md bg-white">
        <table mat-table [dataSource]="attachmentsData()" class="w-full min-w-[600px]">

          <ng-container matColumnDef="docName">
            <th mat-header-cell *matHeaderCellDef class="bg-gray-100 px-4 py-2 font-bold text-gray-600">Document Name
            </th>
            <td mat-cell *matCellDef="let element" class="px-4 py-2">
              <button mat-button color="primary" class="whitespace-normal text-left"
                (click)="openAttachmentDialog(element)">
                <mat-icon fontIcon="description" class="align-middle text-sm mr-1"></mat-icon>
                {{ element['docName'] }}
              </button>
            </td>
          </ng-container>

          <ng-container matColumnDef="timeCreated">
            <th mat-header-cell *matHeaderCellDef class="bg-gray-100 px-4 py-2 font-bold text-gray-600 w-[200px]">Upload
              Date</th>
            <td mat-cell *matCellDef="let element" class="px-4 py-2">{{ element.timeCreated }}</td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"
            class="hover:bg-gray-50 border-b border-gray-100"></tr>
        </table>
      </div>

    </div>
  </div>
  }
</div>